import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { DiscussionListConfig, Community } from "../../../../shared";

@Component({
  selector: "trending-discussions",
  templateUrl: "./trending-discussions.component.html",
})
export class TrendingDiscussionsComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  public community: Community;
  public config: DiscussionListConfig = new DiscussionListConfig();

  ngOnInit() {
    this.route.parent.data.subscribe((data: { community: Community }) => {
      this.community = data.community;
      this.config.filters.community = this.community.name;
      this.config.filters.sortBy = "trending";
    });
  }
}
